import { Translations } from './types';

export const nl: Translations = {
  // Common
  save: 'Opslaan',
  saving: 'Opslaan…',
  cancel: 'Annuleren',
  close: 'Sluiten',
  delete: 'Verwijderen',
  create: 'Aanmaken',
  add: 'Toevoegen',
  apply: 'Toepassen',
  back: 'Terug',
  next: 'Volgende',
  done: 'Klaar ✓',
  loading: 'Laden…',
  copy: 'Kopiëren',
  copied: 'Gekopieerd!',
  restore: 'Herstellen',
  send: 'Versturen',
  invite: 'Uitnodigen',
  untitled: 'Naamloos',
  you: '(jij)',
  unknown: 'Onbekend',
  saveFailed: 'Opslaan mislukt. Probeer het opnieuw.',

  // Topbar (flowchart)
  appSubtitleFlow: 'FlowPlanner-modus',
  projectPlaceholder: 'Project...',
  new: 'Nieuw',
  open: 'Openen',
  history: 'Geschiedenis',
  share: 'Delen',
  controls: 'Bediening',
  logOut: 'Uitloggen',
  simple: 'Eenvoudig',
  advanced: 'Geavanceerd',
  hours: 'Uren',
  days: 'Dagen',
  weeks: 'Weken',
  showStartEnd: 'Toon start&einde:',
  startEndModeDate: 'Datum',
  startEndModeOffset: 'Offset',
  endDisplayDay: 'Dag',
  endDisplayDate: 'Datum',
  endDisplayYear: 'Jaar',
  endDisplayTime: 'Tijd',
  showOptionsBtn: 'Weergave',
  showComments: 'Opmerkingen',
  showSubitemBadgesLabel: 'Subitems',
  quickConnectOnHint: 'Snel verbinden AAN — klik op vakken om te verbinden (ESC of Ctrl+Q om uit te schakelen)',
  quickConnectOffHint: 'Snel verbinden UIT — schakel in om vakken met 2 klikken te verbinden (Ctrl+Q)',
  gantt: 'Gantt',
  project: 'Project',
  projectGanttTitle: 'Project-Gantt: {{name}}',
  zoomIn: 'Inzoomen',
  zoomOut: 'Uitzoomen',
  historyDisabledHint: 'Sla de flowchart eerst op om de geschiedenis te bekijken',
  historyHint: 'Versiegeschiedenis',
  shareDisabledHint: 'Sla de flowchart eerst op om het te delen',
  shareHint: 'Deze flowchart delen',
  usersOnline: '{{count}} gebruiker(s) online',

  // Sidebar
  addLabel: 'TOEVOEGEN',
  editLabel: 'BEWERKEN',
  box: 'Vak',
  note: 'Opmerking',
  start: 'Start',
  category: 'Categorie',
  resources: 'Resources',
  area: 'Top-level',
  viewAllFields: 'Alle velden tonen',
  viewAllFieldsHint: 'Toon duration/assignee-velden altijd en maak ze overal bewerkbaar, in plaats van alleen bij het geselecteerde vak',
  undo: 'Ongedaan',
  redo: 'Opnieuw',
  critical: 'Kritiek pad',
  export: 'Export',
  exportXlsxHint: 'Takenlijst met ID\'s en predecessors — voor import in MS Project of vergelijkbare tools',
  home: 'Start',
  homeActive: 'Start ✓',
  addBox: 'Vak toevoegen',
  addNote: 'Notitie toevoegen',
  addStartDay: 'Startdag toevoegen',
  toggleCategory: 'Categorieën tonen/verbergen',
  toggleResources: 'Resources tonen/verbergen',
  addResource: '+ Resource toevoegen',
  newResourceName: 'Nieuwe naam',
  deleteResource: 'Resource verwijderen',
  noResourcesYet: 'Nog geen resources — voeg namen van teamleden toe om ze aan vakken toe te kennen.',
  duplicateResourceName: 'Er is al een andere resource met exact deze naam — toekenning aan vakken, Gantt-filtering en resource-uren herkennen een resource op naam, dus deze worden als dezelfde resource behandeld. Geef er één een andere naam om ze gescheiden te houden.',
  duplicateResourceNameBlocked: 'Er bestaat al een resource met exact deze naam. Elke resource moet een unieke naam hebben — kies een andere naam.',
  duplicateResourceNameWarning: 'Twee of meer resources hebben exact dezelfde naam. Omdat toekenning en filtering op naam werken, worden ze als één resource behandeld. Geef elke resource een unieke naam om ze gescheiden te houden.',
  assignResources: 'Resources toekennen',
  team: 'Team',
  linkCategory: 'Koppel aan categorie (bepaalt de kleur van de resource)',
  noCategory: 'Geen categorie',
  noTeam: 'Geen team',
  dragToReorderResource: 'Sleep om te verplaatsen binnen het team',
  areaModeActiveHint: 'Top-level-tekenmodus actief — sleep op het canvas om een top-level te maken (klik opnieuw om te stoppen)',
  areaModeHint: 'Top-level toevoegen — sleep een rechthoek op het canvas',
  undoHint: 'Ongedaan maken (Ctrl+Z)',
  redoHint: 'Opnieuw (Ctrl+Y)',
  showCriticalPathHint: 'Kritiek pad op canvas tonen',
  homeSaveFirstHint: 'Sla eerst op om als standaard in te stellen',
  homeRemoveHint: 'Als standaard verwijderen',
  homeSetHint: 'Als standaard instellen (opent automatisch)',
  flowchartModeActive: 'Flowchart-modus (actief)',
  switchToMindmap: 'Naar mindmap-modus',
  flowMode: 'Flowchart',
  mindMode: 'Mind',

  // Modals / panels
  categories: 'Categorieën',
  deleteDepartment: 'Afdeling verwijderen',
  addCategory: '+ Categorie toevoegen',
  newCategory: 'Nieuwe categorie',
  changeLog: 'Wijzigingslog',
  noChangesLogged: 'Nog geen wijzigingen vastgelegd.',
  changesTrackedAfterSave: 'Wijzigingen worden na elke opslag bijgehouden.',
  controlsReminder: 'Bediening',
  restartTour: 'Rondleiding herstarten →',
  link: 'Link',
  openLink: 'Link openen',
  deleteLink: 'Link verwijderen',
  modifyLink: 'Link wijzigen',
  setAutomaticDuration: 'Automatische duur instellen',
  setAutomaticDurationTitle: 'Stel einddatum/tijd in voor automatische duurberekening.',
  setAutomaticDurationIntro: 'Selecteer het gewenste eindmoment voor {{box}}. De duur wordt automatisch berekend op basis van de starttijd, rekening houdend met weekenden, feestdagen en de uitvoeringsmodus.',
  addLink: 'Link toevoegen',
  addHyperlink: 'Hyperlink toevoegen',
  setDate: 'Datum instellen',
  earliestStart: 'Vroegste start',
  execution247: '24/7 uitvoering',
  execution245: '24/5 uitvoering',
  makeMilestone: 'Mijlpaal maken',
  editSubitems: 'Subitems bewerken',
  addUid: 'UID toevoegen',
  editUid: 'UID wijzigen',
  deleteUid: 'UID verwijderen',
  uidLabel: 'UID',
  copyAction: 'Kopiëren',
  duplicate: 'Dupliceren',
  resizeNote: 'Opmerking verschalen',
  makePrivateComment: 'Maak comment privé',
  removePrivateComment: 'Weer openbaar maken',
  privateCommentBadgeHint: 'Privé-comment — alleen zichtbaar voor jou',
  paste: 'Plakken',
  selectAll: 'Alles selecteren',
  setStartDate: 'Startdatum instellen',
  setStartDateTitle: 'Startdatum instellen',
  startConstraintTypeLabel: 'Type',
  startConstraintTypeFixed: 'Vaste startdatum',
  startConstraintTypeEarliest: 'Niet starten vóór',
  earliestStartIntro: '{{box}} mag niet starten vóór:',
  thisBox: 'Dit vak',
  weekNumber: 'Weeknummer',
  weekPlaceholder: 'bijv. 14',
  notBeforeWeek: 'Niet vóór week {{week}}',
  date: 'Datum',
  time: 'Tijd',
  optional: '(optioneel)',
  removeConstraint: 'Beperking verwijderen',
  setDateIntro: '{{box}} wordt vastgezet op deze startdatum, los van de afhankelijkheidsketen.',
  thisTask: 'Deze taak',
  deleteConnection: 'Verbinding verwijderen',
  resizeNoteTitle: 'Notitie verschalen',
  widthPx: 'Breedte (px)',
  heightPx: 'Hoogte (px)',
  unsavedWorkFound: 'Niet-opgeslagen werk gevonden van {{date}}.',
  discard: 'Verwijderen',
  updatedBy: 'Bijgewerkt door',

  // Controls reminder rows
  ctrlScrollWheel: 'Scrollwiel',
  ctrlZoom: 'In- / uitzoomen',
  ctrlRightDrag: 'Rechtsklik + slepen',
  ctrlPan: 'Canvas verschuiven',
  ctrlLeftDrag: 'Linksklik + slepen',
  ctrlSelectMultiple: 'Meerdere objecten selecteren',
  ctrlDragCanvas: 'Slepen op canvas',
  ctrlDrawBox: 'Nieuw vak tekenen',
  ctrlCopyPaste: 'Vakken kopiëren / plakken',
  ctrlUndoRedo: 'Ongedaan maken / opnieuw',
  ctrlQuickConnect: 'Snel verbinden aan/uit',
  ctrlDelete: 'Verwijderen',
  ctrlDeleteSelected: 'Selectie verwijderen',
  ctrlSave: 'Opslaan',

  // Alerts / confirms (flowchart)
  needEditorAccessBoxes: 'Je hebt bewerkingstoegang nodig om vakken toe te voegen',
  needEditorAccessNotes: 'Je hebt bewerkingstoegang nodig om opmerkingen toe te voegen',
  commentHiddenInViewWarning: 'Deze comment wordt geplaatst, maar comments staan momenteel verborgen (View-instellingen) — zet "Comments" aan om deze te zien.',
  needEditorAccessStartDays: 'Je hebt bewerkingstoegang nodig om startdagen toe te voegen',
  needEditorAccessDeleteBoxes: 'Je hebt bewerkingstoegang nodig om vakken te verwijderen',
  needEditorAccessConnections: 'Je hebt bewerkingstoegang nodig om verbindingen te maken',
  needEditorAccessDeleteConnections: 'Je hebt bewerkingstoegang nodig om verbindingen te verwijderen',
  circularReference: 'Deze verbinding is niet toegestaan: het zou een kringverwijzing veroorzaken.',
  confirmNewFlowchart: 'Nieuwe flowchart maken? Niet-opgeslagen wijzigingen gaan verloren.',
  confirmTrashFlowchart: 'Deze flowchart naar de prullenbak verplaatsen?',
  confirmTrashMindmap: 'Deze mindmap naar de prullenbak verplaatsen?',
  deleteFailed: 'Verwijderen mislukt. Probeer het opnieuw.',
  saveHomeFailed: 'Startinstelling opslaan mislukt. Probeer het opnieuw.',
  couldNotLoadShared: 'De gedeelde flowchart kon niet worden geladen. Probeer het opnieuw.',
  flowchartNotFound: 'Flowchart niet gevonden.',
  invalidShareLink: 'Deze deellink is ongeldig of verlopen.',
  couldNotAcceptInvitation: 'Uitnodiging kon niet worden geaccepteerd: {{msg}}',
  projectAccessGranted: 'Je hebt nu {{role}}-toegang tot dit project. Open het via je projectlijst.',
  accessGrantedOpenManually: 'Toegang verleend! De flowchart kon niet automatisch worden geladen — open het via je lijst.',
  somethingWentWrongInvitation: 'Er ging iets mis bij het accepteren van de uitnodiging. Probeer het opnieuw.',

  // Project list
  projectsAndFlowcharts: 'Projecten & flowcharts',
  mindmaps: 'Mindmaps',
  projectsCount: '{{count}} project',
  projectsCountPlural: '{{count}} projecten',
  flowchartsCount: '{{count}} flowchart',
  flowchartsCountPlural: '{{count}} flowcharts',
  mindmapsCount: '{{count}} mindmap',
  mindmapsCountPlural: '{{count}} mindmaps',
  newProject: 'Nieuw project',
  newProjectMaxReached: 'Nieuw project (max. 10 bereikt)',
  projectNamePlaceholder: 'Projectnaam...',
  chooseColor: 'Kies kleur',
  createProject: 'Project aanmaken',
  loadingProjects: 'Projecten laden...',
  newFlowchartInProject: 'Nieuwe flowchart in project',
  newMindmapInProject: 'Nieuwe mindmap in project',
  shareProject: 'Project delen',
  changeColor: 'Kleur wijzigen',
  renameProject: 'Project hernoemen',
  deleteProject: 'Project verwijderen',
  leaveProject: 'Project verlaten',
  noFlowchartsInProject: 'Nog geen flowcharts in dit project',
  noMindmapsInProject: 'Nog geen mindmaps in dit project',
  clickPlusFlowchart: 'Klik op + om een flowchart te maken',
  clickPlusMindmap: 'Klik op + om een mindmap te maken',
  moveTo: 'Verplaatsen naar...',
  ungrouped: 'Niet-gegroepeerd',
  versionHistory: 'Versiegeschiedenis',
  flowchartTitlePlaceholder: 'Flowchart naam...',
  mindmapTitlePlaceholder: 'Mindmap-titel...',
  trash: 'Prullenbak',
  deletedAgo: 'Verwijderd {{date}}',
  daysLeft: 'nog {{days}} d',
  deletingSoon: 'wordt binnenkort verwijderd',
  deletePermanently: 'Definitief verwijderen',
  autoDeleteInfo: 'Items worden na 30 dagen automatisch verwijderd',
  noProjectsYet: 'Nog geen projecten',
  createFirstProjectDesc: 'Maak je eerste project om je flowcharts te ordenen',
  createFirstProject: 'Eerste project maken',
  noMindmapsYet: 'Nog geen mindmaps',
  createFirstMindmapDesc: 'Maak je eerste mindmap via de knop Nieuw in de werkbalk',
  noSavedVersions: 'Geen opgeslagen versies gevonden.',
  latest: '← Nieuwste',
  enterProjectName: 'Voer een projectnaam in',
  maxProjects: 'Maximaal 10 projecten toegestaan',
  createProjectFailed: 'Project aanmaken mislukt. Probeer het opnieuw.',
  updateProjectFailed: 'Project bijwerken mislukt. Probeer het opnieuw.',
  updateProjectColorFailed: 'Projectkleur bijwerken mislukt. Probeer het opnieuw.',
  deleteProjectFailed: 'Project verwijderen mislukt. Probeer het opnieuw.',
  leaveProjectFailed: 'Project verlaten mislukt. Probeer het opnieuw.',
  leaveFlowchart: 'Verlaten',
  leaveFlowchartFailed: 'Verlaten mislukt. Probeer het opnieuw.',
  confirmLeaveFlowchart: 'Je verliest de toegang tot dit item. Het blijft bestaan voor de eigenaar en andere gebruikers.',
  moveFlowchartFailed: 'Flowchart verplaatsen mislukt. Probeer het opnieuw.',
  loadProjectsFailed: 'Projecten laden mislukt. Ververs de pagina.',
  duplicateFailed: 'Dupliceren mislukt',
  restoreFlowchartFailed: 'Flowchart herstellen mislukt. Probeer het opnieuw.',
  createFlowchartFailed: 'Flowchart aanmaken mislukt. Probeer het opnieuw.',
  confirmRestoreVersion: 'Deze versie herstellen? Niet-opgeslagen wijzigingen worden overschreven.',
  couldNotLoadVersion: 'Deze versie kon niet worden geladen. Probeer het opnieuw.',
  confirmDeleteProject: 'Weet je zeker dat je dit project wilt verwijderen? Dit kan niet ongedaan worden gemaakt.',
  confirmDeleteProjectWithFlowcharts: 'Dit project bevat flowcharts. Ze worden verplaatst naar Niet-gegroepeerd. Dit kan niet ongedaan worden gemaakt.',
  confirmLeaveProject: 'Je verliest de toegang tot dit project en de bijbehorende flowcharts. Het project blijft bestaan voor andere leden.',
  confirmPermanentDelete: 'Hiermee worden de flowchart en de volledige versiegeschiedenis definitief verwijderd. Dit kan niet ongedaan worden gemaakt.',
  deleteForever: 'Definitief verwijderen',
  leave: 'Verlaten',
  confirm: 'Bevestigen',

  // Share dialog (flowchart)
  shareLink: 'Deellink',
  enableLinkSharingHint: 'Schakel delen via link in om een deelbare link te maken. Iedereen met de link kan deze flowchart bekijken.',
  inviteByEmail: 'Uitnodigen per e-mail',
  emailPlaceholder: 'email@voorbeeld.nl',
  editor: 'Bewerker',
  viewer: 'Lezer',
  owner: 'Eigenaar',
  addMessageOptional: 'Bericht toevoegen (optioneel)',
  peopleWithAccess: 'Personen met toegang',
  viaProjectSharing: 'Via gedeeld project',
  addedOn: 'Toegevoegd {{date}}',
  projectBadge: 'Project',
  makeOwner: 'Eigenaar maken',
  changeToEditor: 'Wijzigen naar Bewerker',
  changeToViewer: 'Wijzigen naar Lezer',
  removeAccess: 'Toegang intrekken',
  pendingInvitations: 'Openstaande uitnodigingen',
  invitedOn: 'Uitgenodigd {{date}}',
  youAreRole: 'Jij bent {{role}}',
  youHaveNoAccess: 'Je hebt geen toegang',
  invitationSent: 'Uitnodiging verstuurd naar {{email}}',
  invitationFailed: 'Uitnodiging versturen mislukt: {{error}}',
  failedUpdateRole: 'Rol bijwerken mislukt',
  failedRemoveUser: 'Gebruiker verwijderen mislukt',
  failedCancelInvitation: 'Uitnodiging annuleren mislukt',
  confirmRemoveUserAccess: 'Toegang van deze gebruiker intrekken?',
  failedCopyLink: 'Link kopiëren naar klembord mislukt',
  failedUpdateLinkSharing: 'Instellingen voor delen via link bijwerken mislukt',

  // Share project dialog
  shareProjectTitle: 'Project delen',
  anyoneWithLinkProject: 'Iedereen met deze link heeft toegang tot dit project en alle bijbehorende flowcharts',
  enableLinkSharingProjectHint: 'Schakel delen via link in om iedereen met de link toegang tot dit project te geven',
  linkAccess: 'Linktoegang:',
  canView: 'Kan bekijken',
  canEdit: 'Kan bewerken',
  colleaguePlaceholder: 'collega@voorbeeld.nl',
  noUsersYet: 'Nog geen gebruikers',
  invitationPending: 'Uitnodiging openstaand',
  cancelInvitation: 'Uitnodiging annuleren',
  removeUser: 'Gebruiker verwijderen',
  unknownUser: 'Onbekende gebruiker',
  sharingProjectIncludes: 'Een project delen omvat:',
  includesAllFlowcharts: 'Alle flowcharts in dit project',
  includesFutureFlowcharts: 'Toekomstige flowcharts die aan dit project worden toegevoegd',
  includesCreatePermission: 'Rechten om nieuwe flowcharts in dit project te maken (voor bewerkers)',
  enterEmailAddress: 'Voer een e-mailadres in',
  enterValidEmail: 'Voer een geldig e-mailadres in',
  failedSendInvitation: 'Uitnodiging versturen mislukt',
  failedRemoveUserProject: 'Gebruiker verwijderen mislukt',
  failedUpdateUserRole: 'Gebruikersrol bijwerken mislukt',
  failedUpdateAccessRole: 'Toegangsrol bijwerken mislukt',
  confirmRemoveUserProject: 'Deze gebruiker uit het project verwijderen?',

  // Error boundary
  somethingWentWrong: 'Er is iets misgegaan',
  somethingWentWrongIn: 'Er is iets misgegaan in {{label}}',
  unexpectedError: 'Er is een onverwachte fout opgetreden. Je werk is automatisch opgeslagen — herlaad om door te gaan.',
  reloadPage: 'Pagina herladen',

  // Auth (App)
  signInToContinue: 'Log in om door te gaan',
  createYourAccount: 'Maak je account aan',
  emailLabel: 'E-mail',
  passwordLabel: 'Wachtwoord',
  showPassword: 'Wachtwoord tonen',
  hidePassword: 'Wachtwoord verbergen',
  minChars: 'Minimaal 6 tekens',
  signIn: 'Inloggen',
  signUp: 'Registreren',
  noAccountSignUp: 'Nog geen account? Registreer',
  haveAccountSignIn: 'Al een account? Log in',
  forgotPassword: 'Wachtwoord vergeten?',
  passwordResetSent: 'E-mail voor wachtwoordherstel verstuurd. Controleer je inbox.',
  passwordResetFailed: 'Kon de e-mail voor wachtwoordherstel niet versturen. Probeer het later opnieuw.',
  checkEmailConfirm: 'Controleer je e-mail om je account te bevestigen!',
  authFailed: 'Authenticatie mislukt',
  sessionExpiredElsewhere: 'Je bent uitgelogd — je sessie is beëindigd, mogelijk omdat je elders opnieuw bent ingelogd. Log opnieuw in.',
  enterEmailFirst: 'Voer eerst je e-mailadres in.',
  awaitingApproval: 'Wacht op goedkeuring',
  awaitingApprovalDesc: 'Je account ({{email}}) is aangemaakt en wacht tot een beheerder toegang goedkeurt.',
  awaitingApprovalNote: 'Je kunt inloggen zodra je account is goedgekeurd.',
  signOut: 'Uitloggen',
  newVersionAvailable: 'Er is een nieuwe versie van MindYourPlan beschikbaar. Herlaad om compatibiliteitsproblemen te voorkomen.',
  reloadNow: 'Nu herladen',

  // Tour
  tourStepOf: 'STAP {{current}} VAN {{total}}',
  tourTitleName: 'Flowchart naam',
  tourDescName: 'Geef je flowchart hier een duidelijke naam. Deze verschijnt in je projectlijst en in de koptekst van de Gantt-grafiek.',
  tourTitleNew: 'Nieuwe flowchart',
  tourDescNew: 'Begin met een leeg canvas. Opent in de modus Eenvoudig zodat je je eerst op de structuur kunt richten.',
  tourTitleOpen: 'Openen',
  tourDescOpen: 'Bekijk al je opgeslagen flowcharts en projecten. Hier kun je flowcharts in projectmappen ordenen.',
  tourTitleSave: 'Opslaan',
  tourDescSave: 'Slaat je flowchart op in de database. Met automatisch opslaan aan worden wijzigingen vanzelf gesynchroniseerd terwijl je werkt.',
  tourTitleShare: 'Delen',
  tourDescShare: 'Nodig collega\'s uit per e-mail of genereer een deelbare link. Wijs ze toe als Lezer of Bewerker. Beschikbaar zodra de flowchart is opgeslagen.',
  tourTitleAutosave: 'Automatisch opslaan',
  tourDescAutosave: 'Indien aan wordt elke wijziging automatisch opgeslagen en realtime gesynchroniseerd met medewerkers die dezelfde flowchart bekijken.',
  tourTitleMode: 'Weergave-opties',
  tourDescMode: 'Selecteer een vak om de duur, toegewezen persoon en voortgang te bewerken. Zet hier "Alle velden tonen" aan om dit altijd en op elk vak te tonen en bewerken — ideaal voor Gantt-planning.',
  tourTitleConnect: 'Snel verbinden',
  tourDescConnect: 'Schakel dit in en klik vervolgens op twee vakken om er een pijl tussen te tekenen — slepen is niet nodig. Druk op Ctrl+Q of Esc om te schakelen.',
  tourTitleGantt: 'Gantt-grafiek',
  tourDescGantt: 'Genereert een Gantt-tijdlijn op basis van je flowchart. Vul duur en toegewezen personen in op vakken in de modus Geavanceerd voor het beste resultaat.',
  tourTitleZoom: 'Zoomen',
  tourDescZoom: 'Zoom in/uit met deze knoppen of scroll met het muiswiel over het canvas.',
  tourTitleAddBox: 'Vak toevoegen',
  tourDescAddBox: 'Voegt een taakvak toe aan het canvas. Tip: je kunt ook direct op het canvas slepen om een vak in elke maat en positie te tekenen.',
  tourTitleAddNote: 'Notitie toevoegen',
  tourDescAddNote: 'Voegt een tekstballon toe — handig voor aantekeningen, beslissingen of context die niet in een taakvak thuishoort.',
  tourTitleStartDay: 'Startdag',
  tourDescStartDay: 'Plaatst een tijdlijnanker op het canvas. Vakken die na een startdag worden verbonden, nemen de offset over — ideaal voor parallelle trajecten in je Gantt-grafiek.',
  tourTitleCategory: 'Categorieën',
  tourDescCategory: 'Definieer teams of afdelingen en wijs elk een kleur toe. Vakken nemen automatisch hun categoriekleur over.',
  tourTitleResources: 'Resources',
  tourDescResources: 'Voeg hier de namen van je teamleden toe en ken er vanuit het Name-veld van een vak één of meer aan toe.',
  tourTitleCanvas: 'Canvasbediening',

  // Gantt panel
  ganttChartTitle: 'Gantt-grafiek: {{title}}',
  show: 'Tonen:',
  quarters: 'Kwartalen',
  months: 'Maanden',
  weeksLevel: 'Weken',
  daysLevel: 'Dagen',
  hoursLevel: 'Uren',
  workDaysOnly: 'Alleen werkdagen',
  timelineBtn: 'Tijdlijn',
  ganttDurationLabel: 'Duur',
  hideNonWorkingDay: 'Niet-werkdagen verbergen',
  setTimelineDates: 'Tijdlijndatums instellen',
  timelineFrom: 'Van',
  timelineTo: 'Tot',
  autoFit: 'Automatisch passend',
  filterByResource: 'Filteren op resource',
  filterByCategory: 'Filteren op category',
  noMatchingTasks: 'Geen taken voor deze resource',
  clearFilter: 'Filter wissen',
  selectAllResources: 'Alles selecteren',
  resourceSummaryMode: 'Eén samenvattingsregel per resource',
  planSettings: 'Planinstellingen',
  planDefaultMode: 'Standaardmodus',
  planStartDate: 'Startdatum project',
  planHolidays: 'Feestdagen / niet-werkdagen',
  planWorkDays: 'Werkdagen',
  noHolidays: 'Nog geen feestdagen toegevoegd',
  workdayMode: 'Workday',
  workdayHours: 'Werkdaguren',
  hideNonWorkingHours: 'Niet-werkuren verbergen',
  showSubitemsInGantt: 'Subitems tonen',
  showAreaGroupsInGantt: 'Area-toplevel tonen',
  showRegularBoxesInGantt: 'Reguliere boxen tonen',
  showStartEndColumnInGantt: 'Start/einde kolom tonen',
  end: 'Einde',
  savedTimelines: 'Opgeslagen tijdlijnen',
  saveAsPreset: 'Opslaan als tijdlijn',
  presetNamePlaceholder: 'Naam',
  applyPreset: 'Toepassen',
  useThisSavedPreset: 'Gebruik deze opgeslagen selectie',
  showInFlowplan: 'Tonen in FlowPlanner',
  selectSpecificResourceTimes: 'Specifieke resource-tijden selecteren',
  cell: 'cel',
  hrsPerDay: '24 uur/dag',
  holidays: 'Vrije dagen',
  showAllDependencies: 'Alle afhankelijkheden tonen',
  criticalPath: 'Kritiek pad',
  autoSort: 'Auto sorteren',
  autoSortHint: 'Rijen herordenen om de totale lengte van afhankelijkheidspijlen te minimaliseren',
  backToFlowPlanner: 'Terug naar FlowPlanner',
  exportGantt: 'Gantt exporteren',
  hideEmptyGanttRows: 'Lege rijen verbergen',
  hideEmptyGanttRowsHint: 'Rijen zonder balk binnen het huidige timeline view worden verborgen, zowel op het scherm als in de export.',
  filteredExport: 'Filtered Export',
  onlyExportSelectedRows: 'Alleen geselecteerde rijen exporteren',
  switchViewToSelectRows: 'Wissel weergave om rijen voor export te selecteren',
  onlyExportSelectedRowsHint: 'Vink per rij aan welke je wilt meenemen via het vakje ernaast — zolang dit aanstaat, toont de Gantt-weergave ze in de volgorde waarin ze geëxporteerd worden. Zet het uit voor de normale volgorde, dan wordt gewoon alles geëxporteerd.',
  switchViewToSelectRowsHideEmptyNote: 'Let op: indien ingeschakeld, wordt de optie "Lege rijen verbergen" automatisch uitgezet zodat rijen weer gesleept/herordend kunnen worden.',
  selectAllRows: 'Alles selecteren',
  selectNoRows: 'Niets selecteren',
  rowsSelectedCount: '{{count}} van {{total}} rijen geselecteerd',
  savedExportSelections: 'Opgeslagen selecties',
  dragToReorder: 'Sleep om te herordenen',
  setDateMarker: 'Datum: {{date}}',
  earliestStartMarker: 'Vroegste start: {{value}}',
  nonWorkingDays: 'Niet-werkdagen',
  nonWorkingDaysDesc: 'Deze dagen worden overgeslagen in de Gantt-tijdlijn',
  noHolidaysYet: 'Nog geen vrije dagen toegevoegd',
  weekAbbr: 'Wk',
  clickToRemove: 'Klik om te verwijderen',
  clickToAddNonWorking: 'Klik om als niet-werkdag toe te voegen',
  task: 'Taak',
  reorderArrowHint: 'Rijen herordenen om de totale lengte van afhankelijkheidspijlen te minimaliseren',

  // Mindmap
  appSubtitleMind: 'Mindmap-modus',
  mindmapPlaceholder: 'Mindmap...',
  shareMindmap: 'Deze mindmap delen',
  saveFirstHistory: 'Sla eerst op om de geschiedenis te bekijken',
  saveFirstShare: 'Sla eerst op om te delen',
  collapseToLevel: 'Inklappen tot niveau {{level}}',
  expandAll: 'Alles uitklappen',
  priorityMatrix: 'Prioriteitenmatrix',
  searchMindmapPlaceholder: 'Zoektekst…',
  searchMindmap: 'Zoek en markeer overeenkomende knooppunten',
  clearSearch: 'Zoekopdracht wissen',
  searchMatchCount: '{{count}} resultaat/resultaten gevonden',
  switchToMono: 'Naar één kleur',
  switchToMulti: 'Naar meerdere kleuren',
  addChildNode: 'Subknoop toevoegen (Tab)',
  deleteSelected: 'Selectie verwijderen (Delete)',
  hidePriorities: 'Prioriteiten verbergen',
  showPriorities: 'Prioriteiten tonen',
  setPriority: 'Prioriteit instellen',
  priority: 'Prioriteit {{p}}',
  removePriority: 'Prioriteit verwijderen',
  noPriority: 'Geen prioriteit',
  highlightNode: 'Markeren',
  removeHighlight: 'Markering verwijderen',
  markCompleted: 'Markeer als voltooid',
  removeCompleted: 'Markeer als niet voltooid',
  completedRemovePrio: 'Verwijder alle voltooid',
  completedRemovePrioTitle: 'Alle voltooide items uit de matrix verwijderen — de mindmap-knopen zelf blijven bestaan',
  completedDeleteAll: 'Verwijder alle voltooid óók uit mindmap',
  completedDeleteAllTitle: 'Voltooide items (en hun subitems) permanent uit de mindmap verwijderen — kan niet ongedaan worden gemaakt',
  confirmDeleteCompletedNodes: '{{count}} voltooide item(s) (en eventuele subitems) permanent uit de mindmap verwijderen? Dit kan niet ongedaan worden gemaakt.',
  scheduleDaysOption: '{{n}} dagen',
  scheduleDaysTitle: 'Aantal dagkolommen in de Schedule-weergave',
  addPriorityNode: 'Add priority',
  addPriorityNodeTitle: 'Nieuw mindmap-item direct in dit kwadrant/deze dag toevoegen',
  addPriorityBranchLabel: 'Branch',
  addPriorityQuadrantLabel: 'Kwadrant',
  addPriorityValuePlaceholder: 'Tekst invoeren...',
  editPriorityTitle: 'Titel bewerken',
  backToMindmap: 'Terug naar mindmap',
  switchToFlowchart: 'Naar Flowchart-modus',
  mindmapModeActive: 'Mindmap-modus (actief)',
  setAsDefaultMindmap: 'Als standaard-mindmap instellen (opent automatisch)',
  removeAsDefault: 'Klik om als standaard te verwijderen',
  saveFirstDefault: 'Sla eerst op om als standaard in te stellen',
  notePlaceholder: 'Typ hier je notitie...',
  noteTitle: 'Notitie',
  bold: 'Vet',
  italic: 'Cursief',
  underline: 'Onderstreept',
  bulletList: 'Opsommingslijst',
  numberedList: 'Genummerde lijst',
  textLarger: 'Tekst groter',
  textSmaller: 'Tekst kleiner',
  increaseIndent: 'Inspringing vergroten',
  decreaseIndent: 'Inspringing verkleinen',
  cannotLinkCircular: 'Verbinden niet mogelijk: kringverwijzing gedetecteerd.',
  centralTopic: 'Centraal onderwerp',
  priorities: 'Prioriteiten',
  multiColor: 'Meerkleurig',
  monoColor: 'Eén kleur',
  childNode: 'Subknoop',
  priorityLabel: 'Prioriteit',
  deleteNote: 'Notitie verwijderen',
  addChild: 'Subknoop toevoegen',
  modifyNote: 'Notitie wijzigen',
  addNoteAction: 'Notitie toevoegen',
  rename: 'Hernoemen',
  moveToNode: 'Verplaatsen naar…',
  unlinkMindmap: 'Mindmap ontkoppelen',
  linkMindmap: 'Mindmap koppelen…',
  linkMindmapTitle: 'Mindmap koppelen',
  linkMindmapDesc: 'De geselecteerde mindmap wordt als subboom aan de geselecteerde knoop gekoppeld.',
  noOtherMindmaps: 'Geen andere mindmaps beschikbaar.',
  emptyNode: '(leeg)',
  mmCtrlDblClick: 'Dubbelklik op knoop',
  mmEditText: 'Tekst bewerken',
  mmCtrlDrag: 'Klik + slepen',
  mmMoveNode: 'Knoop verplaatsen',
  mmShiftDrag: 'Shift + slepen',
  mmMoveParent: 'Naar andere ouder verplaatsen',
  mmSelectMultiple: 'Meerdere knopen selecteren',
  mmScrollDrag: 'Scrollen / rechts slepen',
  mmZoomPan: 'Zoomen / verschuiven',
  mmCreateChild: 'Subknoop maken',
  mmCreateSibling: 'Naastliggende node maken',
  mmNavigate: 'Navigeren tussen knopen',
  mmDeleteNode: 'Knoop verwijderen',

  // Subitems panel
  subitemsPanelTitle: 'Subitems',
  subitemAdd: '+ Subitem toevoegen',
  subitemDuration: 'Duur',
  subitemAddDependency: '+ Afhankelijkheid toevoegen',
  subitemTotalDuration: 'Totale duur',
  subitemUntitled: 'Naamloos subitem',
  subitemEmptyState: 'Nog geen subitems — voeg er een toe om deze box op te delen in kleinere geplande stappen.',
  durationDeterminedBySubitems: 'Bepaald door subitems',
  durationNowFromSubitems: 'Duration wordt nu bepaald door subitems',
  durationNowManual: 'Duration wordt weer op box-niveau bepaald',
};
